import React from 'react';
import { Icon } from '@iconify/react';

const NotificationPrintView = ({ notification, approvedByName = '', handleImageClick, isExportMode = false }) => {
  if (!notification) return null;
  const rootId = isExportMode ? 'printable-notification' : undefined;
  return (
    <div id={rootId} className="row">
      {notification.tblWorkOrders?.workOrderNumber && (
        <div className="col-12 mb-4">
          <a
            href={`${process.env.REACT_APP_WEB_URL}/work-orders?workordernumber=${notification.tblWorkOrders.workOrderNumber}`}
            target="_blank"
            rel="noopener noreferrer"
            className="badge bg-success-100 text-md text-success"
          >
            Linked to Work Order {notification.tblWorkOrders.workOrderNumber}
          </a>
        </div>
      )}
      {(notification.assetId || notification.areaId) && (
        <div className="col-md-9 mb-4">
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <img
              style={{
                width: '45px',
                height: '45px',
                borderRadius: '50%',
                border: '1px solid #eee',
                objectFit: 'cover',
              }}
              src={
                notification.asset?.assetImage
                  ? `${process.env.REACT_APP_SPACES_BASE}/${notification.asset.assetImage}`
                  : `${process.env.REACT_APP_SPACES_BASE}/placeholder.png`
              }
              alt="Asset"
            />
            <strong>
              {notification.assetId
                ? `${notification.asset?.assetNumber || ''} - ${notification.asset?.assetDescription || ''}`
                : `${notification.area?.code || notification.area?.areaCode || ''} - ${notification.area?.name || ''}`}
            </strong>
            {notification.asset?.assetFloc ? `(${notification.asset.assetFloc})` : ''}
          </div>
        </div>
      )}
      <div className="col-md-3 mb-4">
        <div className="fw-bold mb-2">Priority</div>
        {notification.priority && (
          <>
            <span
              className={`d-inline-block rounded-circle bg-${notification.priority.colours?.bootstrapName || 'secondary'} me-1`}
              style={{ width: 10, height: 10 }}
            ></span>
            {notification.priority.name}
          </>
        )}
      </div>
      <div className="col-6 mb-4">
        <div className="fw-bold mb-3">Requested By</div>
        {notification.requesterName}
        {notification.requesterEmail && (
          <div className="text-primary text-sm">
            <span style={{ position: 'relative', top: '-4px', marginRight: '4px' }}>
              <Icon icon="mage:email" className="icon line-height-1" />
            </span>
            <a href={`mailto:${notification.requesterEmail}`}>{notification.requesterEmail}</a>
          </div>
        )}
        {notification.requesterPhone && (
          <div className="text-muted text-sm">
            <span className="text-primary" style={{ position: 'relative', top: '-4px', marginRight: '4px' }}>
              <Icon icon="mage:phone" className="icon line-height-1" />
            </span>
            {notification.requesterPhone}
          </div>
        )}
      </div>
      <div className="col-3 mb-4">
        <div className="fw-bold mb-3">Department</div>
        {notification.department?.name || 'N/A'}
      </div>
      <div className="col-6 mb-4">
        <div className="fw-bold mb-3">Assigned Team</div>
        {notification.tblTeams && (
          <>
            <span
              className={`d-inline-flex align-items-center justify-content-center rounded-circle text-white me-8 bg-${notification.tblTeams.colours?.bootstrapName || 'secondary'}`}
              style={{ width: 32, height: 32 }}
            >
              {(notification.tblTeams.teamName || '')
                .split(' ')
                .slice(0, 2)
                .map((w) => w[0])
                .join('')
                .toUpperCase()}
            </span>
            {notification.tblTeams.teamName}
          </>
        )}
      </div>
      <div className="col-6 mb-4">
        <div className="fw-bold mb-3">Created</div>
        {new Date(notification.createdAt).toLocaleDateString('en-GB', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        })}
        {' '}at{' '}
        {new Date(notification.createdAt).toLocaleString('en-GB', {
          hour: '2-digit',
          minute: '2-digit',
        })}
      </div>
      {notification.approvedBy && notification.approvedDate && (
        <>
          <div className="col-6 mb-4">
            <div className="fw-bold mb-3">Approved By</div>
            {approvedByName}
          </div>
          <div className="col-6 mb-4">
            <div className="fw-bold mb-3">Approved Date</div>
            {new Date(notification.approvedDate).toLocaleDateString('en-GB', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            })}
            {' '}at{' '}
            {new Date(notification.approvedDate).toLocaleString('en-GB', {
              hour: '2-digit',
              minute: '2-digit',
            })}
          </div>
        </>
      )}
      <div className="col-12 mb-4">
        <div className="fw-bold mb-3">Description</div>
        {notification.notificationDescription}
      </div>
      <div className="row">
        {notification.notificationImages?.map((image, index) => (
          <div key={index} className="col-6 mb-3">
            <div className='hover-scale-img border radius-16 overflow-hidden p-2'>
              <img
                src={`${process.env.REACT_APP_SPACES_BASE}/${image}`}
                alt={`notification-${index}`}
                style={{
                  width: '100%',
                  height: 'auto',
                  objectFit: 'cover',
                  cursor: handleImageClick ? 'pointer' : 'default',
                }}
                onClick={() =>
                  handleImageClick &&
                  handleImageClick(`${process.env.REACT_APP_SPACES_BASE}/${image}`)
                }
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotificationPrintView;

